export var dateToTime=function(e,t){return t?(e.getTime()-t.getTime())/1e3:0};